(function () {

  const kombucha_benefits_slider_list = document.querySelectorAll('.js_kombucha_benefits_slider')

  for (let i = 0; i < kombucha_benefits_slider_list.length; i++) {
    const slider = kombucha_benefits_slider_list[i]
    initKombuchaBenefitsSlider(slider)
  }

  function initKombuchaBenefitsSlider (slider) {
    const sliderWrapEl = slider.closest('.image-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    // const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    // const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {

      spaceBetween: 40,
      slidesPerView: 1,
      // centeredSlides: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: false
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: false,
          enabled: false
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
          // spaceBetween: 150,
          spaceBetween: 20,
          pagination: false,
          enabled: false
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 50,
          pagination: false,
          enabled: false
        },
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: false,
      },
      // navigation: {
      //   nextEl: swiperButtonNext,
      //   prevEl: swiperButtonPrev,
      // },
    }

    // Override from theme
    // if (window.productSliderV1Override) {
    //   sliderOptions = window.productSliderV1Override(slider)
    // }

    new Swiper(slider, sliderOptions)
  }

})()
